// Parse MM:SS time format to seconds
export function parseTimeToSeconds(timeString: string): number | null {
  if (!timeString || typeof timeString !== 'string') return null

  // Handle various formats: MM:SS, M:SS, SS
  const parts = timeString.trim().split(':')

  if (parts.length === 1) {
    // Just seconds
    const seconds = Number.parseFloat(parts[0])
    return Number.isNaN(seconds) ? null : seconds
  }
  if (parts.length === 2) {
    // MM:SS format
    const minutes = Number.parseInt(parts[0], 10)
    const seconds = Number.parseFloat(parts[1])

    if (Number.isNaN(minutes) || Number.isNaN(seconds)) return null
    if (seconds >= 60) return null // Invalid seconds

    return minutes * 60 + seconds
  }

  return null
}

// Format seconds to MM:SS display format
export function formatSecondsToTime(seconds: number): string {
  if (!seconds || seconds <= 0) return ''

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = (seconds % 60).toFixed(2)
  const [wholeSecs, decimal] = remainingSeconds.split('.')

  if (decimal === '00') {
    return `${minutes}:${wholeSecs.padStart(2, '0')}`
  }
  return `${minutes}:${wholeSecs.padStart(2, '0')}.${decimal}`
}

// Format CSS value (in min/100m) to MM:SS/100m display format
export function formatCSS(cssValue: number): string {
  if (!cssValue || cssValue <= 0) return ''

  const totalSeconds = cssValue
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = (totalSeconds % 60).toFixed(0)

  return `${minutes}:${seconds.padStart(2, '0')}/100m`
}

// Calculate and format pace for running tests
export function calculateRunPace(timeInSeconds: number, distance: number): string {
  if (!timeInSeconds || !distance) return ''

  const paceInSecondsPerKm = timeInSeconds / distance
  const minutes = Math.floor(paceInSecondsPerKm / 60)
  const seconds = Math.floor(paceInSecondsPerKm % 60)

  return `${minutes}:${seconds.toString().padStart(2, '0')}/km`
}

// Parse HH:MM:SS time format to seconds
export function parseTimeToSecondsFromHHMMSS(timeString: string): number | null {
  if (!timeString || typeof timeString !== 'string') return null

  const parts = timeString.trim().split(':')

  if (parts.length === 1) {
    // Just seconds
    const seconds = Number.parseFloat(parts[0])
    return Number.isNaN(seconds) ? null : seconds
  }
  if (parts.length === 2) {
    // MM:SS format
    const minutes = Number.parseInt(parts[0], 10)
    const seconds = Number.parseFloat(parts[1])

    if (Number.isNaN(minutes) || Number.isNaN(seconds)) return null
    if (seconds >= 60) return null // Invalid seconds

    return minutes * 60 + seconds
  }
  if (parts.length === 3) {
    // HH:MM:SS format
    const hours = Number.parseInt(parts[0], 10)
    const minutes = Number.parseInt(parts[1], 10)
    const seconds = Number.parseFloat(parts[2])

    if (Number.isNaN(hours) || Number.isNaN(minutes) || Number.isNaN(seconds)) return null
    if (minutes >= 60 || seconds >= 60) return null // Invalid minutes or seconds

    return hours * 3600 + minutes * 60 + seconds
  }

  return null
}

// Format seconds to HH:MM:SS display format
export function formatSecondsToTimeHHMMSS(seconds: number): string {
  if (!seconds || seconds <= 0) return ''

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = (seconds % 60).toFixed(0)

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.padStart(2, '0')}`
  }
  return `${minutes}:${remainingSeconds.padStart(2, '0')}`
}
